import { resolveOktaScopeBanner } from "../../utils/oktaAssessmentScopeBanner.js";

const TONE_CLASS = {
  amber: "border-amber-500/20 bg-amber-500/10 text-amber-100/95",
  sky: "border-sky-500/20 bg-sky-500/10 text-sky-100/90",
};

/**
 * Okta workspace scope banner (POST-ARC.7) — mirrors Auth0 recommended-scope strip.
 *
 * @param {{ capabilities?: Record<string, unknown> | null }} props
 */
export default function OktaAssessmentScopeBanner({ capabilities }) {
  const banner = resolveOktaScopeBanner(capabilities);
  if (!banner) return null;

  const toneClass = TONE_CLASS[banner.tone] || TONE_CLASS.sky;

  return (
    <div className={`border-b px-4 py-2 text-center text-xs ${toneClass}`}>
      <span className="font-medium">{banner.message}</span> {banner.detail}
    </div>
  );
}
